<template>
    <v-form
            ref="modifyPieceForm"
            @submit.prevent=""
            class="fill-height of-y"
            :disabled="loading"
    >
        <div class="">
            <div class="d-flex align-center primary pl-3 pr-2">
                <div class="flex-grow-1 sub--text">
                    {{piece.id ? 'Edit Piecework' : 'Create Piecwork'}}
                </div>
                <div v-if="!piece.id">
                    <v-btn
                            icon
                            color="white"
                            small
                            @click="$emit('dismiss')"
                    >
                        <v-icon small>mdi-close</v-icon>
                    </v-btn>
                </div>
            </div>
            <v-divider></v-divider>
            <div class="px-2 pb-1" style="overflow-x: hidden; overflow-y: hidden">
                <v-text-field
                        label="Job Description"
                        hide-details="auto"
                        v-model="piece.description"
                        @change="changesMade = true"
                        :rules="[validationRules.required, validationRules.notNull]"
                />
                <v-text-field
                        label="Job Rate"
                        hide-details="auto"
                        v-model="piece.rate"
                        type="number"
                        @change="changesMade = true"
                        :rules="[validationRules.required, validationRules.notNull, validationRules.notZero]"
                />

                <v-autocomplete
                        label="Piecework Type"
                        hide-details="auto"
                        no-data-text="No available types"
                        v-model="piece.type"
                        item-text="description"
                        item-value="id"
                        :items="[{id: 0, description: 'Normal'}, {id: 1, description: 'Enter units at clock out'}]"
                        @input="changesMade = true"
                        @click.clear="changesMade = true"
                />

                <v-text-field
                        v-if="piece.type === 1"
                        label="Unit Description"
                        hide-details="auto"
                        v-model="piece.unitDescription"
                        @change="changesMade = true"
                        :rules="[validationRules.required, validationRules.notNull, validationRules.notZero]"
                />

                <v-menu
                        ref="startTimeMenu"
                        v-model="startTimeMenu"
                        :close-on-content-click="false"
                        :nudge-right="40"
                        :return-value.sync="piece.startTime"
                        transition="scale-transition"
                        offset-y
                        max-width="290px"
                        min-width="290px"
                >
                    <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                                v-model="piece.startTime"
                                label="Start Time"
                                readonly
                                v-bind="attrs"
                                v-on="on"
                                hide-details="auto"
                                @change="changesMade = true"
                                :rules="[validationRules.required, validationRules.notNull, validationRules.notZero]"
                        ></v-text-field>
                    </template>
                    <v-time-picker
                            v-if="startTimeMenu"
                            v-model="piece.startTime"
                            full-width
                            @click:minute="$refs.startTimeMenu.save(piece.startTime)"
                    ></v-time-picker>
                </v-menu>

                <v-menu
                        ref="endTimeMenu"
                        v-model="endTimeMenu"
                        :close-on-content-click="false"
                        :nudge-right="40"
                        :return-value.sync="piece.endTime"
                        transition="scale-transition"
                        offset-y
                        max-width="290px"
                        min-width="290px"
                >
                    <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                                v-model="piece.endTime"
                                label="End Time"
                                readonly
                                v-bind="attrs"
                                v-on="on"
                                hide-details="auto"
                                @change="changesMade = true"
                                :rules="[validationRules.required, validationRules.notNull, validationRules.notZero]"
                        ></v-text-field>
                    </template>
                    <v-time-picker
                            v-if="endTimeMenu"
                            v-model="piece.endTime"
                            full-width
                            @click:minute="$refs.endTimeMenu.save(piece.endTime)"
                    ></v-time-picker>
                </v-menu>

                <v-autocomplete
                        label="Limit To Farm"
                        hide-details="auto"
                        no-data-text="No available farms"
                        v-model="piece.fkFarm"
                        item-text="description"
                        item-value="id"
                        :items="farms"
                        @input="changesMade = true"
                        clearable
                        @click.clear="changesMade = true"
                />

                <v-text-field
                        label="Export ID"
                        hide-details="auto"
                        v-model="piece.exportID"
                        @change="changesMade = true"
                        :rules="[validationRules.required, validationRules.notNull]"
                />

            </div>
            <div class="text-right pr-2 pt-2 pb-2">
                <v-btn
                        @click="validateSave()"
                        fab
                        small
                        color="secondary"
                        :loading="loading"
                        :disabled="!changesMade || loading"
                >
                    <v-icon v-if="!loading">mdi-content-save</v-icon>
                </v-btn>
            </div>
        </div>
    </v-form>
</template>

<script>
import {mapGetters} from 'vuex'
import {validationRules} from "../../../core/codeFunctions";

export default {
    components: {},
    props: {
        editPiece: Object
    },
    data() {
        return {
            piece: null,
            loading: false,
            validationRules: validationRules,
            changesMade: false,
            startTimeMenu: false,
            endTimeMenu: false
        }
    },
    watch: {
        editPiece: {
            deep: true,
            immediate: true,
            handler(val) {
                this.changesMade = false
                console.log(val)
                this.piece = JSON.parse(JSON.stringify(val))
            }
        },
    },
    methods: {
        validateSave() {
            if (!this.$refs.modifyPieceForm.validate())
                return false

            this.$emit('save', {emp: this.piece, ref: this})
        }
    },
    computed: {
        ...mapGetters(['emp', 'farms'])
    },
}
</script>

<style scoped>

</style>